// Sugalarm — 224px tabular-nums hero value. Inline-style is intentional
// for the values that change per-render (color, animation toggle).

import type { Zone } from "../../lib/types";
import { zoneColor } from "../../lib/glucose";

interface Props {
  value: string | number;
  zone: Zone;
  stale?: boolean;
  /** Disable pulse animation (e.g. when value is unknown). */
  pulse?: boolean;
  /** Either a px number or any CSS length string (e.g. `clamp(96px, 16vw, 200px)`). */
  size?: number | string;
}

export function HeroValue({
  value,
  zone,
  stale = false,
  pulse,
  size = 224,
}: Props) {
  const heroColor = stale ? "var(--ink-3)" : zoneColor(zone);
  const isUrgent = zone === "urgent_low" || zone === "urgent_high";
  const animate = (pulse ?? isUrgent) && !stale;
  return (
    <div
      style={{
        fontFamily: "var(--hero-font)",
        fontWeight: 600,
        fontSize: size,
        lineHeight: 0.86,
        letterSpacing: "-0.045em",
        color: heroColor,
        fontVariantNumeric: "tabular-nums",
        animation: animate ? "pulseHero 2s ease-in-out infinite" : "none",
        transition: "color 200ms",
      }}
    >
      {value}
    </div>
  );
}
